<app-dashboard-page
  [organizationId]="organization?._id"
  [intervention]="intervention"
  [hasAdminPermissions]="hasAdminPermissions"
></app-dashboard-page>
